// @ts-ignore
import img from '@/assets/images/404.png';
import { ElScrollbar } from '@qsxy/element-plus-react';
import '@/assets/404.scss';
import { useMount } from 'ahooks';
import { FC } from 'react';

const NotFound: FC = () => {
	useMount(() => {
		const ele = document.getElementById('loading');
		if (ele) {
			ele.parentNode.removeChild(ele);
		}
	});
	return (
		<ElScrollbar>
			<div className="ttn-404">
				<img src={img} />
				<div className="ttn-404-title">
					<h2>页面走丢了...</h2>
					<h4>远方的朋友你好！非常抱歉，您所请求的页面不存在！</h4>
					<h4>请仔细检查您输入的网址是否正确。</h4>
				</div>
			</div>
		</ElScrollbar>
	);
};

export default NotFound;
